import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, CreditCardIcon, LockIcon, ShieldIcon, ZapIcon } from 'lucide-react';
import { CTAButton, CHECKOUT_URL } from './Shared';
const productImage = 'https://cdn.magicpatterns.com/uploads/srADDhXjTXZfBV39xwdG21/Gemini_Generated_Image_nci5nunci5nunci5.png';
export function Hero() {
  return <header className="relative overflow-hidden bg-brand-surface pb-8 pt-6 md:pb-16 md:pt-16" data-id="element-100" data-mp="129h37ug97cgl">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-101" data-mp="1274nlnxyxe6p">
        <div className="absolute -left-20 top-12 h-64 w-64 rounded-full border border-brand-gold/40" data-id="element-102" data-mp="x8jnrpmmowis" />
        <div className="absolute right-[6%] top-10 font-display text-[130px] leading-none text-brand-purple/10" data-id="element-103" data-mp="sd48ct8z2sk9">✦</div>
        <div className="absolute bottom-8 left-[8%] h-44 w-44 rounded-full border-[18px] border-brand-purpleMist" data-id="element-104" data-mp="3d1a4za4glt8j" />
        <div className="absolute bottom-[16%] right-[7%] h-3 w-3 rounded-full bg-brand-goldBright" data-id="element-105" data-mp="3825xcnx6o3kb" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-106" data-mp="3j9u1r1hjpsmv">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-107" data-mp="3o7vktmez1ryc">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-brand-gold/45 bg-white px-3 py-1 shadow-sm md:mb-5 md:px-4 md:py-1.5" data-id="element-108" data-mp="399jlt944m740">
            <span className="text-xs md:text-sm" data-id="element-109" data-mp="30iaxysfp6ajs">🔮</span>
            <span className="font-title text-[10px] font-bold tracking-[.16em] text-brand-purple md:text-xs" data-id="element-110" data-mp="30gq6jbooj7q5">LUMEN AKASHA™</span>
          </div>

          <div className="mx-auto max-w-5xl" data-id="element-111" data-mp="2qkdcudt4wtve">
            <h1 className="font-serif text-[32px] leading-[1.05] tracking-tight text-brand-purpleDark md:text-[clamp(2.35rem,6.6vw,5.1rem)] md:leading-[0.99] md:tracking-[-0.045em]" data-id="element-112" data-mp="2qlelkbmoh49y">
              <span className="block" data-id="element-113" data-mp="2hl9sz7m58afu">Sesiones más profundas,</span>
              <span className="relative z-0 inline-block px-1.5 text-brand-purpleDark before:absolute before:inset-x-0 before:bottom-[0.08em] before:-z-10 before:h-[0.45em] before:-rotate-1 before:bg-brand-goldBright/70" data-id="element-114" data-mp="2ljpe15ynz8qm">
                más seguras
              </span>
              <span className="block" data-id="element-115" data-mp="ibozao1l0svy">y sin improvisar.</span>
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-[14px] font-semibold text-brand-textLight md:mt-5 md:text-xl" data-id="element-116" data-mp="dd5c6kb95b20">
              El conocimiento ya lo tenés. El sistema para aplicarlo con autoridad profesional, ahora también.
            </p>
          </div>

          <div className="mx-auto mt-4 flex max-w-xl justify-center md:mt-8" data-id="element-117" data-mp="162c9xh2vtwm7">
            <motion.img src={productImage} alt="Mega Pack Maestro de Gemoterapia con los cuatro tomos y cinco bonus" initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.65,
            ease: 'easeOut'
          }} className="h-auto w-[75%] max-w-[260px] drop-shadow-2xl md:w-full md:max-w-none" draggable={false} fetchPriority="high" data-id="element-118" data-mp="111ok2yqe3ltk" />
          </div>

          <div className="mx-auto mt-3 max-w-3xl space-y-2 md:space-y-3" data-id="element-119" data-mp="21by0lbsix4ei">
            <h2 className="font-title text-lg font-bold tracking-wide text-brand-purpleDark md:text-3xl" data-id="element-120" data-mp="26a96jbfp6urg">
              MEGA PACK MAESTRO DE GEMOTERAPIA™
            </h2>
            <div className="gold-rule mx-auto max-w-xs" aria-hidden="true" data-id="element-121" data-mp="2b2k9yo9ncyor" />
            <p className="mx-auto max-w-xl font-serif text-[14px] font-semibold leading-snug text-brand-text md:text-xl md:leading-normal" data-id="element-122" data-mp="2fzarzh50i4ct">
              ✨ Ya sea que estés comenzando tu camino con los cristales o que ya atiendas pacientes y quieras hacerlo con más criterio y estructura, el Mega Pack fue creado para vos.
            </p>
            <CTAButton href={CHECKOUT_URL} className="cta-shimmer relative mt-2 overflow-hidden px-6 py-3 text-sm md:mt-2 md:px-10 md:py-5 md:text-xl" data-id="element-123" data-mp="umhfqh2m8tqz">
              <span className="relative z-10" data-id="element-124" data-mp="4bdwfeqaa7o3">→ QUIERO MI MEGA PACK AHORA</span>
            </CTAButton>
          </div>

          <div className="mx-auto mt-4 flex max-w-3xl flex-wrap justify-center gap-x-3 gap-y-1.5 text-[10px] text-brand-muted md:mt-5 md:gap-x-4 md:gap-y-2 md:text-sm" data-id="element-125" data-mp="3vi6z6n0q6euq">
            <span className="flex items-center gap-1" data-id="element-126" data-mp="e77ibopw7dij">
              <CheckCircle2Icon className="h-3 w-3 md:h-4 md:w-4 text-brand-purple" data-id="element-127" data-mp="9bs8r8yx43rx" />
              Garantía 7 días
            </span>
            <span data-id="element-128" data-mp="3ho69eirr426i">📥 Listo para imprimir o usar en tablet</span>
            <span className="flex items-center gap-1" data-id="element-129" data-mp="3csihhvlvwuxb">
              <LockIcon className="h-3 w-3 md:h-4 md:w-4 text-brand-purple" data-id="element-130" data-mp="3rg3mxw68f68e" />
              Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-131" data-mp="3mp3naj5qaa27">
              <CreditCardIcon className="h-3 w-3 md:h-4 md:w-4 text-brand-purple" data-id="element-132" data-mp="3mnaizail81xd" />
              Mercado Pago
            </span>
          </div>

          <div className="mt-5 flex flex-wrap justify-center gap-1.5 text-[9px] font-semibold md:mt-7 md:gap-2 md:text-sm" data-id="element-133" data-mp="2u1hjpawi35fc">
            <span className="rounded-full border border-brand-purple/20 bg-white px-2.5 py-1.5 md:px-3 md:py-2" data-id="element-134" data-mp="19h2pmgeovg3v">
              <BookOpenIcon className="mr-1 inline h-3 w-3 md:h-4 md:w-4 text-brand-purple" data-id="element-135" data-mp="1eaosxhyyq7n0" />
              100% PDF
            </span>
            <span className="rounded-full border border-brand-purple/20 bg-white px-2.5 py-1.5 md:px-3 md:py-2" data-id="element-136" data-mp="14jaxpme1ntzo">
              <ZapIcon className="mr-1 inline h-3 w-3 md:h-4 md:w-4 text-brand-purple" data-id="element-137" data-mp="1s8n7ooh74631" />
              Acceso en 5 min
            </span>
            <span className="rounded-full border border-brand-purple/20 bg-white px-2.5 py-1.5 md:px-3 md:py-2" data-id="element-138" data-mp="1x7q099fzoju4">🔮 Todos los niveles</span>
            <span className="rounded-full border border-brand-gold/50 bg-brand-goldLight/40 px-2.5 py-1.5 text-brand-goldDark md:px-3 md:py-2" data-id="element-139" data-mp="1na21m8f9is6o">
              <ShieldIcon className="mr-1 inline h-3 w-3 md:h-4 md:w-4" data-id="element-140" data-mp="7sig2kbgptvs" />
              🎁 Colección profesional
            </span>
          </div>
        </motion.div>
      </div>
    </header>;
}